var _path, _rect, _rect2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 55,
    viewBox: "0 0 50 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 25V49.3376C49 50.43 48.5317 51.4361 47.8567 52.0471C47.2061 52.6361 46.4005 52.8422 45.55 52.4901C45.1388 52.3198 44.7954 52.1252 44.5334 51.91C43.8498 51.3488 43.1133 51.147 42.3621 51.2928C41.6994 51.4214 41.1368 51.8053 40.7201 52.1124C40.5737 52.2203 40.4416 52.3213 40.3174 52.4162C40.0347 52.6323 39.7933 52.8168 39.518 52.9798C39.1554 53.1945 38.8645 53.2845 38.5856 53.2723C37.5416 53.2263 36.9433 53.0382 36.2223 52.7649C36.1144 52.724 36.0032 52.6808 35.8874 52.6359C35.185 52.3636 34.3111 52.0248 32.9665 51.7093C31.1338 51.2793 29.8951 51.8158 28.8757 52.3527C28.7692 52.4089 28.6668 52.4636 28.5676 52.5166C27.7249 52.967 27.1171 53.2918 26.2129 53.2716C25.3329 53.2518 24.6509 52.9099 23.7825 52.4744C23.7187 52.4424 23.6539 52.4099 23.588 52.377C22.6695 51.9188 21.5071 51.3785 20.0224 51.7064C19.0779 51.915 18.1928 52.3042 17.4524 52.6298C17.2298 52.7277 17.0203 52.8198 16.8261 52.8996C15.9248 53.2698 15.2282 53.4461 14.4895 53.2923C14.0701 53.205 13.6248 53.0374 13.0946 52.8128C12.965 52.7579 12.8285 52.6988 12.6866 52.6373C12.2767 52.4597 11.8215 52.2625 11.3569 52.0918C10.0585 51.6145 8.51125 51.2709 6.61976 51.7086L5.6871 51.9246C3.29016 52.4799 1 50.6605 1 48.2013V25C1 11.7451 11.7452 1 25 1C38.2548 1 49 11.7452 49 25Z",
    stroke: "#F9CD11",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.6984,
    y: 14.9654,
    width: 6.34921,
    height: 10.2394,
    rx: 3.1746,
    fill: "#F9CD11"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9525,
    y: 14.9654,
    width: 6.34921,
    height: 10.2394,
    rx: 3.1746,
    fill: "#F9CD11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2153 36.0887C39.2153 36.0887 40.5641 39.7925 39.225 41.4453C37.8859 43.0981 34.091 41.9467 34.091 41.9467",
    stroke: "#F9CD11",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2748 41.2756C17.2748 41.2756 13.5198 42.5493 11.878 41.1917C10.2363 39.8341 11.4625 36.0886 11.4625 36.0886",
    stroke: "#F9CD11",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKgLogo);
export default __webpack_public_path__ + "static/media/KGLogo.b8b139bf82c57a2b27493108a6f0c63f.svg";
export { ForwardRef as ReactComponent };